import React from 'react';
import { FaPlus } from 'react-icons/fa';  // Import the FaPlus icon from react-icons

class addButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isHovered: false,
        };
    }

    handleMouseEnter = () => {
        this.setState({ isHovered: true });
    };

    handleMouseLeave = () => {
        this.setState({ isHovered: false });
    };

    render() {
        const { isHovered } = this.state;
        const {
            onClick,
            size = '60px', // Default size of the button
            backgroundColor = '#002948',
            hoverColor = '#2A6AA9',
            plusColor = '#fff',
            moveDistance = '10px', // Move distance when hovered
        } = this.props;

        const buttonStyle = {
            borderRadius: '50%',
            width: size,
            height: size,
            backgroundColor: isHovered ? hoverColor : backgroundColor, // Change color on hover
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed', // Keep it fixed at the bottom-right corner
            bottom: '5vw',
            right: '5vw',
            zIndex: 1000,
            transition: 'transform 0.3s ease, background-color 0.3s ease', // Smooth hover transition
            cursor: 'pointer',
            transform: isHovered ? `translateY(-${moveDistance})` : 'translateY(0)', // Move the entire button up
        };

        const iconStyle = {
            fontSize: `calc(${size} / 2.5)`, // Correct size of the FaPlus icon
            color: plusColor, // Color of the plus sign
        };

        return (
            <div
                style={buttonStyle}
                onClick={onClick}
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
            >
                <FaPlus style={iconStyle} /> {/* Use FaPlus icon */}
            </div>
        );
    }
}

export default addButton;